/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { Col, Row, Space } from "antd";
import { TabContext, TabList } from '@mui/lab';
import SalesPrice from "../../../../Product/Setup/components/Price/SalesPrice";
import { Button, Box, Tab } from "@mui/material";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { QuickLinks } from "../../../../Shared/components/BreadCrumbNew/QuickLinks";
import { CustomAccordion } from "../../../../Shared/components/AccordionComponent";
import qucikLinksActions from "../../../../Dashboard/redux/actions";
import { capitalizeFirstLetter, checkCRUDViewPermission, checkCRUDPermission } from "../../../../../helpers/utilities";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import productActions from "../../../../Product/Product/redux/actions";
import { SalesPriceHeadCustomer, SalesDiscountHeadCustomer } from "../../../../../config/constant";
import { AESEncrypt, AESDecrypt } from "../../../../../helpers/Crypto";
import { useEventListener } from "../../../../../helpers/useEventListener"
import SalesDiscount from "../../../../Product/Setup/components/Price/SalesDiscount";
import addressActions from "../../../../Admin/Address/redux/actions";


const CustomerView = (props) => {
    const { readDetails, readError } = useSelector(state => state.crudReducer);
    let { customerId } = useParams();

    const [name, setName] = useState('');
    const { roleManagement } = useSelector(state => state.authReducer);
    const dispatch = useDispatch();
    const { history } = props;
    const [deleteModal, setDeleteModal] = useState(false);
    const [factBox, setFactBox] = useState([]);
    const prevReadDetails = usePrevious(readDetails);
    const [showDetails, setShowDetails] = useState(true);
    const decryptedId = AESDecrypt(customerId);

    const [value, setValue] = useState('sales-price');
    const [apiUrl, setApiUrl] = useState('salesPriceAgreement');
    const [heads, setHeads] = useState(SalesPriceHeadCustomer);

    const childRef = useRef('');
    const priceRef = useRef('');
    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setName(data.name);
    }

    const menus = [
        {
            "name": "Create Order",
            "link": "",
        },
        {
            "name": "Create Sales Bill",
            "link": `/sales/sales-management/self-bill/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Collect Payment",
            "link": `/sales/sales-management/customer-payment/${AESEncrypt(decryptedId)}/create`
        },
        {
            "name": "Invoice History",
            "link": `/sales/transactions/${AESEncrypt(decryptedId)}/invoice-history`
        },
        {
            "name": "Order History",
            "link": ""
        },
        {
            "name": "Settlement",
            "link": `/sales/report-and-enquiry/${AESEncrypt(decryptedId)}/customer-settlement`
        },
        {
            "name": "Transaction History",
            "link": `/sales/transactions/${AESEncrypt(decryptedId)}/customer-transaction`
        }
    ];


    const loadTasksDelete = () => {
        history.push("/sales/sales-management/all-customers");
    }


    useEffect(() => {
        if (decryptedId === 0) {
            loadTasksDelete();
        } else {
            if (roleManagement !== '' && checkCRUDViewPermission('All Customers', 'view', history, 'Sales')) {
                dispatch({ type: crudActions.READ_DETAILS_START, id: decryptedId, url: "customerProfile" });
                dispatch({
                    type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products', filter: {
                        where: { "and": [{ status: 'ACTIVE' }] },
                        order: 'id desc'
                    }
                });
            }
        }
        return () => {
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
        };
    }, [decryptedId, roleManagement]);

    const handleKeyDown = (e) => {
        if (e.altKey && e.keyCode === 69) {
            e.preventDefault();
            history.push(`/sales/sales-management/all-customers/${AESEncrypt(decryptedId)}/edit`);
        } else if (e.altKey && e.keyCode === 66) {
            e.preventDefault();
            history.push(`/sales/sales-management/self-bill/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 84) {
            e.preventDefault();
            history.push(`/sales/transactions/${AESEncrypt(decryptedId)}/customer-transaction`);
        } else if (e.altKey && e.keyCode === 73) {
            e.preventDefault();
            history.push(`/sales/transactions/${AESEncrypt(decryptedId)}/invoice-history`);
        } else if (e.altKey && e.keyCode === 80) {
            e.preventDefault();
            history.push(`/sales/sales-management/customer-payment/${AESEncrypt(decryptedId)}/create`);
        } else if (e.altKey && e.keyCode === 77) {
            e.preventDefault();
            history.push(`/sales/report-and-enquiry/${AESEncrypt(decryptedId)}/customer-settlement`);
        }
    }

    useEventListener("keydown", handleKeyDown);


    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            if (readDetails.facts) {
                setFactBox(readDetails.facts);
                if (readDetails.isHold) {
                    menus.splice(0, 3);
                }
                if (readDetails.isNew) {
                    let iH = menus.findIndex((d, i) => d.name === 'Invoice History');
                    menus[iH]['disabled'] = true;
                    let oH = menus.findIndex((d, i) => d.name === 'Order History');
                    menus[oH]['disabled'] = true;
                    let s = menus.findIndex((d, i) => d.name === 'Settlement');
                    menus[s]['disabled'] = true;
                    let tH = menus.findIndex((d, i) => d.name === 'Transaction History');
                    menus[tH]['disabled'] = true;
                }
                setTimeout(function () {
                    dispatch({ type: qucikLinksActions.QUICKLINKS_START, menus: menus, toggle: true, factBox: readDetails.facts, component: "All Customers" });
                    childRef?.current?.handleAdjustHeight();
                }, 200)
            }
            setShowDetails(false);
        }
    }, [readDetails, readError]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 'sales-price') {
            setApiUrl('salesPriceAgreement');
            setHeads(SalesPriceHeadCustomer);
        } else {
            setApiUrl('sales-discounts');
            setHeads(SalesDiscountHeadCustomer);
        }
    };

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                cls={'newImg'}
                img={SalesIcon}
                title={'Sales'}
                closeLink={'/sales/sales-management/all-customers'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'All Customers', 'link': '/sales/sales-management/all-customers' }, { 'label': 'Customer Details', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.listTableSticky, { [classes.scrollBorder]: !showDetails })}>
                <div id="containerDiv" className={clsx(classes.stickyContainer)}>
                    <CustomAccordion
                        title={"View Customer"}
                        top={"0"}
                        topVisible={"50px"}
                        zIndex={9}
                        showDetails={showDetails}
                        index={0}
                        ref={childRef}
                        component={
                            <>
                                {
                                    showDetails === false && readDetails &&
                                    <>
                                        <Row gutter={50}>
                                            <Col xxl={5} xl={5} lg={12} md={12} sm={12} xs={8} >
                                                <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}>General</Typography>
                                            </Col>
                                            <Col xxl={19} xl={19} lg={12} md={12} sm={12} xs={16} className={classes.textAlignRight}>
                                                <Space direction="horizontal" align="center">
                                                    {
                                                        roleManagement !== '' && readDetails?.isNew && checkCRUDPermission('All Customers', 'deletable', 'Sales') &&
                                                        <Button
                                                            key="delete"
                                                            onClick={() => onDelete(readDetails)}
                                                            color="primary"
                                                            variant="contained"
                                                            className={clsx(classes.deleteBtn)}>
                                                            Delete</Button>
                                                    }
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('All Customers', 'edit', 'Sales') &&
                                                        <Link to={`/sales/sales-management/all-customers/${AESEncrypt(decryptedId)}/edit`} className={clsx(classes.modalBtn, classes.bold, classes.marginRight0)}>Edit</Link>
                                                    }
                                                </Space>
                                            </Col>
                                            <Col xxl={10} xl={10} lg={6} md={8} sm={12} xs={24}>
                                                <Typography className={clsx(classes.aTitle, classes.margin20t)}>{readDetails.name}</Typography>
                                                <Typography variant={'subtitle1'} className={clsx(classes.fonSize13)}><span className={clsx(classes.bold, classes.colorLine)}>{readDetails.serialNo}</span>
                                                    <span className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}> {readDetails.type}</span></Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} className={classes.mobileViewHold}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Hold</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.isHold ? 'Yes' : 'No'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.margin20t, 'MuiInputLabel-shrink', classes.fonSize13)}>Price Includes Tax</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.priceIncludesTax ? 'Yes' : 'No'}</Typography>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin20t)}>Sales Rep</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.salesRep?.name || '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Mobile Number</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mobile}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Email</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.email ? readDetails.email : '---'}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Classification</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{capitalizeFirstLetter(readDetails?.classification || '---')}</Typography>
                                            </Col>
                                            <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Preferred Language</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.language ? readDetails.language.name : '---'}</Typography>
                                            </Col>
                                            <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Group</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.group ? readDetails.group.name : '---'}</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>GST Details</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>GST Type </Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.taxType?.name || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>GST Code</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.partyGst ? readDetails.partyGst.code : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>GST Number (GSTIN)</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.gstin ? readDetails.gstin : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Identity Number</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.pan ? readDetails.pan : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col xxl={9} xl={9} lg={24} md={24} sm={24} xs={24}></Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Address</Typography>
                                            </Col>
                                            <Col xxl={10} xl={10} lg={20} md={20} sm={24} xs={24}>
                                                <Row gutter={50}>
                                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14, classes.margin20t)}>{readDetails.address1 || '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.area ? readDetails.area.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.city ? readDetails.city.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.state ? readDetails.state.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.country ? readDetails.country.name : '---'}</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.pincode ? readDetails.pincode.code : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={14} xl={14} lg={24} md={24} sm={24} xs={24}></Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Other Contact Details</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>

                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.margin30t)}>Contact Name</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.contactName ? readDetails.contactName : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.margin30t)}>Alternate Name (Optional)</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.tradingName ? readDetails.tradingName : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24} >
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.margin30t)}>Alternate Phone</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.alternateMobile ? readDetails.alternateMobile : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={9} xl={9} lg={9} md={9} sm={24} xs={24}></Col>
                                            <Col xxl={19} xl={19} lg={19} md={19} sm={24} xs={24}></Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} >
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Payment Info</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>

                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.margin30t)}>Method of payment (MOP)</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.mop ? readDetails.mop.method : '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={12} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.fonSize13, 'MuiInputLabel-shrink', classes.margin30t)}>Currency</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.currency ? readDetails.currency.name : '---'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={14} xl={14} lg={14} md={14} sm={24} xs={24}></Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Younote Info</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Younote ID</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.customerBusiness?.serialNo || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>In-App Status</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.inAppStatus ? capitalizeFirstLetter(readDetails.inAppStatus) : 'No'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>In-AppTransactions</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.inAppTransition ? 'Yes' : 'No'}</Typography>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xxl={9} xl={9} lg={9} md={9} sm={24} xs={24}></Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Typography variant={'h6'} className={clsx(classes.customLink, classes.margin35t, classes.typographyHeader, classes.bold)}>Other Taxes</Typography>
                                            </Col>
                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Row gutter={50} className={classes.marginTop10}>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Cash Discount</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.cashDiscount?.code || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Tax Code</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.taxCode?.code || '---'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>TCS</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.tcsBoolean ? 'Yes' : 'No'}</Typography>
                                                    </Col>
                                                    <Col xxl={5} xl={5} lg={6} md={8} sm={8} xs={24}>
                                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>TDS</Typography>
                                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails.tdsBoolean ? 'Yes' : 'No'}</Typography>
                                                    </Col>
                                                    <Col xxl={4} xl={4} lg={6} md={8} sm={12} xs={24}>
                                                        {
                                                            readDetails.tcsBoolean ? <>
                                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>TCS Type</Typography>
                                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{readDetails?.tcs?.name || '---'}</Typography>
                                                            </> : ''
                                                        }

                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </>
                                }
                                {
                                    showDetails === true && (
                                        <div style={{ textAlign: "center" }}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                    />
                    <CustomAccordion
                        title={"Sales Price Details"}
                        top={"49"}
                        topVisible={"150px"}
                        zIndex={7}
                        showDetails={showDetails}
                        index={1}
                        ref={childRef}
                        component={
                            <>
                                <TabContext className={clsx(classes.tableRoot)} value={value}>
                                    <Box className={clsx(classes.tabDesign)}>
                                        <TabList onChange={handleChange}>
                                            <Tab className={classes.Bordertab_1} label="Sales Price" value={'sales-price'} />
                                            <Tab className={classes.Bordertab_2} label="Sales Discount" value={'sales-discount'} />
                                        </TabList>
                                    </Box>
                                    {
                                        showDetails === false ? readDetails && <>
                                            {
                                                value === 'sales-price' ? <SalesPrice topBarView={false}
                                                    ref={priceRef}
                                                    {...props}
                                                    customerId={decryptedId}
                                                    groupId={readDetails?.groupId}
                                                    title={value.replace("-", " ")}
                                                    apiUrl={apiUrl} heads={heads} /> : <SalesDiscount topBarView={false}
                                                        ref={priceRef}
                                                        {...props}
                                                        customerId={decryptedId}
                                                        groupId={readDetails?.groupId}
                                                        title={value.replace("-", " ")}
                                                        apiUrl={apiUrl} heads={heads} />
                                            }
                                        </>
                                            : <div className={classes.textAlignCenter}>
                                                <div className={classes.loadMoreCircle}></div>
                                            </div>
                                    }

                                </TabContext>
                            </>
                        }
                    />
                    {/* <CustomAccordion
                        title={"Customer Products"}
                        top={"113"}
                        topVisible={"250px"}
                        zIndex={5}
                        showDetails={showDetails}
                        index={2}
                        ref={childRef}
                        component={
                            <>
                                <Row>
                                    <Col span={8}>
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                fullWidth
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={16} className={classes.textAlignRight}>

                                    </Col>
                                </Row>
                                {

                                    showDetails === false && readDetails &&
                                    <></>
                                }
                                {
                                    showDetails === true && (
                                        <div style={{ textAlign: "center" }}>
                                            <div className={classes.loadMoreCircle}></div>
                                        </div>
                                    )
                                }
                            </>
                        }
                        lastContent={true}
                    /> */}
                </div>
            </div>
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={decryptedId}
                loadTasks={() => loadTasksDelete()}
                name={name}
                url={'customerProfile'}
                title={'Customer Profile'}
                visible={deleteModal}
            />
            <QuickLinks menus={menus} factBox={factBox} component={"All Customers"}
                onParentFunction={() => childRef?.current?.handleAdjustHeight()}></QuickLinks>
        </React.Fragment >
    )
}
export default CustomerView